import 'select2';

class Form {
  constructor() {
    this.sel = {
      select: 'select',
      dataLayerForm: 'data-datalayer-form form',
      dataLayerFormContainer: '[data-datalayer-form]',
      dataLayerItem: '[data-include-in-data-layer]',
      formReplacementContainer: '.formwidget-submit-text',
      downloadFileUrl: 'data-download-file-url',
      downloadFileField: '[name$=".DownloadFileURL.Value"]',
      pendingDownloadKey: 'careuk-pending-download',
    };
    this.dataLayerForms = {};
    this.formParentsBeingWatched = [];

    this.init = this.init.bind(this);
    this.bindEvents = this.bindEvents.bind(this);
    this.initSelects = this.initSelects.bind(this);
    this.addNativeEventTrigger = this.addNativeEventTrigger.bind(this);
    this.prepareDataLayer = this.prepareDataLayer.bind(this);
    this.observeForm = this.observeForm.bind(this);
    this.formMutationCallback = this.formMutationCallback.bind(this);
    this.startFileDownload = this.startFileDownload.bind(this);
    this.wrapDownloadFormSubmit = this.wrapDownloadFormSubmit.bind(this);
    this.downloadThenRedirect = this.downloadThenRedirect.bind(this);
    this.flushPendingDownload = this.flushPendingDownload.bind(this);
  }

  bindEvents() {
    this.initSelects();
    this.observeForm();
    this.wrapDownloadFormSubmit();
    this.flushPendingDownload();
  }

  // https://stackoverflow.com/a/14570614/351426
  observeForm() {
    const MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
    if (MutationObserver) {
      // have the observer observe for changes in children
      $(this.sel.dataLayerFormContainer).each((_, element) => {
        const parent = $(element).parent()[0];
        if (!this.formParentsBeingWatched.includes(parent)) {
          const mutationObserver = new MutationObserver(this.formMutationCallback);
          mutationObserver.observe($(element).parent()[0], { childList: true, subtree: true });
          this.formParentsBeingWatched.push(parent);
        }
      });
    }
  }

  formMutationCallback(mutationsList) {
    mutationsList.forEach((mutation) => {
      let isRemovedForm = false;
      let $removedForm;
      let isAddedReplacement = false;
      if (mutation.type === 'childList') {
        mutation.removedNodes.forEach((removedNode) => {
          if ($(removedNode).is(this.sel.dataLayerFormContainer)) {
            isRemovedForm = true;
            $removedForm = $(removedNode);
          }
        });
        mutation.addedNodes.forEach((addedNode) => {
          if ($(addedNode).is(this.sel.formReplacementContainer)) {
            isAddedReplacement = true;
          }
        });
      }
      if (isRemovedForm && isAddedReplacement) {
        const $dataLayerInputs = $removedForm.find(':input[data-include-in-data-layer]');
        const formName = $removedForm.attr('data-datalayer-form');
        this.prepareDataLayer($dataLayerInputs, formName);
        // _observer.disconnect();
      }
    });
  }

  // Kentico's shared submit handler (window.kentico.updatableFormHelper.submitForm) either swaps
  // the form's markup in place ("Display text" mode) or navigates the browser via `location.href`
  // ("Redirect to page"/"Redirect to URL" mode, driven by a JSON {redirectTo} response) with no DOM
  // change at all. A download form needs to trigger a real file download either way, so watching the
  // DOM (as dataLayer prep does, above) only covers the first case. This wraps the shared handler
  // once instead: forms without our download marker attribute are handed straight to the original
  // handler, untouched; marked forms get the same two branches re-run here, with a download call
  // added at the point each branch has confirmed a genuine success (the JSON branch only ever runs on
  // success; the swap branch is also used to re-render validation errors, so it is gated on the
  // presence of the success marker, same as the dataLayer mutation watcher above).
  wrapDownloadFormSubmit() {
    if (!window.kentico || !window.kentico.updatableFormHelper
      || window.kentico.updatableFormHelper.submitForm.isDownloadFormWrapped) {
      return;
    }

    const originalSubmitForm = window.kentico.updatableFormHelper.submitForm;

    const wrappedSubmitForm = (event) => {
      const form = event.target;
      // Kentico re-renders the form on any field change/blur, and that re-render does not go through
      // the widget's rendering configuration, so the marker attribute set server-side survives only
      // the very first render. The hidden DownloadFileURL field does survive, because it is posted
      // and re-bound like any other field - so that is the reliable source, with the attribute kept
      // as a fallback for the un-re-rendered case.
      const downloadField = form.querySelector(this.sel.downloadFileField);
      const downloadUrl = (downloadField && downloadField.value)
        || form.getAttribute(this.sel.downloadFileUrl);

      if (!downloadUrl) {
        originalSubmitForm(event);
        return;
      }

      event.preventDefault();
      const formData = new FormData(form);
      const xhr = new XMLHttpRequest();

      xhr.addEventListener('load', () => {
        const contentType = xhr.getResponseHeader('Content-Type');

        if (contentType && contentType.indexOf('application/json') !== -1) {
          this.downloadThenRedirect(downloadUrl, JSON.parse(xhr.response).redirectTo);
        } else {
          // The success response is just the submit-message element itself, preceded by whitespace,
          // so the marker can be the parsed set's own (non-text) node rather than a descendant.
          // filter() covers that; find() still covers it being nested in a wrapper.
          const $parsed = $($.parseHTML(xhr.response));
          const isSuccess = $parsed.filter(this.sel.formReplacementContainer).length > 0
            || $parsed.find(this.sel.formReplacementContainer).length > 0;
          const currentScrollPosition = $(window).scrollTop();
          $(`#${form.getAttribute('data-ktc-ajax-update')}`).replaceWith(xhr.response);
          $(window).scrollTop(currentScrollPosition);

          if (isSuccess) {
            this.startFileDownload(downloadUrl);
          }
        }
      });

      xhr.open('POST', form.action);
      xhr.send(formData);
    };
    wrappedSubmitForm.isDownloadFormWrapped = true;

    window.kentico.updatableFormHelper.submitForm = wrappedSubmitForm;
  }

  // Both redirect modes ("Redirect to URL" and "Redirect to page") come back as the same JSON
  // {redirectTo} response and navigate the browser, which cancels a download this page started
  // moments earlier - the file request never gets committed. So the download is handed to the page
  // being navigated TO: the URL is parked in sessionStorage (same-origin, survives navigation) and
  // picked up by flushPendingDownload during that page's init, where nothing is unloading. A
  // cross-origin destination cannot read our sessionStorage, so those download here first and delay
  // the navigation instead. Either way the redirect still happens if the download cannot be set up,
  // so a download problem never strands the visitor on a submitted form.
  downloadThenRedirect(fileUrl, redirectTo) {
    const redirect = () => {
      if (redirectTo) {
        window.location.href = redirectTo;
      }
    };

    if (!fileUrl) {
      redirect();
      return;
    }

    let isSameOrigin = false;
    try {
      isSameOrigin = new URL(redirectTo, window.location.origin).origin === window.location.origin;
    } catch (e) {
      isSameOrigin = false;
    }

    if (isSameOrigin) {
      try {
        window.sessionStorage.setItem(this.sel.pendingDownloadKey, fileUrl);
        redirect();
        return;
      } catch (e) {
        // sessionStorage unavailable (private mode, blocked storage) - fall through
      }
    }

    this.startFileDownload(fileUrl);
    setTimeout(redirect, 1200);
  }

  // Picks up a download parked by downloadThenRedirect before the browser navigated here.
  flushPendingDownload() {
    let fileUrl = null;
    try {
      fileUrl = window.sessionStorage.getItem(this.sel.pendingDownloadKey);
      if (fileUrl) {
        window.sessionStorage.removeItem(this.sel.pendingDownloadKey);
      }
    } catch (e) {
      return;
    }

    if (fileUrl) {
      this.startFileDownload(fileUrl);
    }
  }

  // A temporary anchor is used so the file downloads instead of the browser navigating to it and
  // rendering it inline. The anchor is removed asynchronously: detaching it from the document in the
  // same tick as the click can cancel the download before the browser has committed the request.
  // eslint-disable-next-line class-methods-use-this
  startFileDownload(fileUrl) {
    if (!fileUrl) {
      return;
    }

    // Deliberately unstyled - an empty anchor has no content and so occupies no space anyway.
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = '';
    document.body.appendChild(link);
    link.click();
    setTimeout(() => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    }, 5000);
  }

  // eslint-disable-next-line class-methods-use-this
  prepareDataLayer($inputs, formName) {
    window.dataLayer = window.dataLayer || {};
    const formDataLayer = {};
    $inputs.each((_index, element) => {
      const inputName = $(element).attr('data-include-in-data-layer');
      if (inputName) {
        formDataLayer[inputName] = $(element).val();
      }
    });
    formDataLayer.event = 'formSubmit';
    formDataLayer.form = formName;

    window.dataLayer.push(formDataLayer);
  }

  // eslint-disable-next-line class-methods-use-this
  select2CustomMatch(params, data) {
    if (!Object.prototype.hasOwnProperty.call(params, 'term') || params.term.trim() === '') return data;
    if (typeof data.text === 'undefined') return null;
    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) === 0) return $.extend({}, data, true);
    return null;
  }

  initSelects() {
    const $selects = $(this.sel.select).not('.select2-hidden-accessible');
    if ($selects.length) {
      $selects.filter('[data-searchable]').on('select2:open', () => {
        $('.select2-search__field')[0].focus();
      });

      // 30/06/21 - JR - Adding this as select2 doesnt fire
      // native js change events, which sadly is what kentico is listening for
      // - Kentico's code uses ele.addEventListener("change", ...)
      // on kentico's form javascript for updating validation/visiblity.
      // see this issue on select2 github https://github.com/select2/select2/issues/1908
      $selects.each((_, element) => {
        const options = {};
        if ($(element)[0].hasAttribute('data-searchable')) {
          options.matcher = this.select2CustomMatch;
        } else {
          options.minimumResultsForSearch = Infinity;
        }
        if ($(element).attr('data-placeholder')) {
          options.placeholder = $(element).attr('data-placeholder');
          options.allowClear = false;
        }
        $(element).select2(options);
        $(element).one('change', this.addNativeEventTrigger);
      });
    }
  }

  addNativeEventTrigger(e) {
    if (window.document.documentMode) {
      // (IE doesnt support Event() constructor)
      // https://caniuse.com/?search=Event()
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', false, true);
      e.currentTarget.dispatchEvent(evt);
    } else {
      const event = new Event('change');
      e.currentTarget.dispatchEvent(event);
    }
    $(e.currentTarget).one('change', this.addNativeEventTrigger);
  }

  init() {
    this.bindEvents();
  }
}

export default new Form();
